// extracted by mini-css-extract-plugin
module.exports = {"btn_menu":"TabItem_btn_menu__3agCQ","menu_container":"TabItem_menu_container__19iu9","menu_item":"TabItem_menu_item__27HVO","container":"TabItem_container__CIe4A"};